import React, { useEffect, useMemo, useRef, useState } from "react";
import { Grid, Typography, Box, Card, CardContent } from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  AccountCircle,
  Email,
  Lock,
  Phone,
  AssignmentInd,
  LocationOn,
} from "@mui/icons-material";
import "../../styles/UserStyles.css";
import "../../styles/App.scss";
import { STAFFS } from "../../component/common/Routes/AppRoutes";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import CustomButton from "../../component/ui/FormFields/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  resetStaffDetail,
  staffUpdateRequest,
  StaffViewRequest,
} from "../../redux/Staff/StaffAction";
import { toast, ToastContainer } from "react-toastify";
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from "../../redux/Common/selectorAction";
import Loading from "../../component/ui/Loading";
import {
  convertDateFormat,
  convertStaffDateFormat,
  formatDateWithAmPm,
} from "../../Style";
import {
  fetchRoleDetailsRequest,
  resetRoleState,
} from "../../redux/Roles/actions/RolesActions";
export default function UpdateStaff() {
    const location = useLocation();
    
         const page= location.state?.pageEdit?? 0;
  const navigate = useNavigate();
  const viewStaff = useSelector((state) => state.staffs?.Staff || {});
  const viewLoading = viewStaff?.loading;
  const editLoading = viewStaff?.updateLoading;
  const roles = useSelector((state) => state.roles?.roles || {});

  const dispatch = useDispatch();
  const { staffId } = useParams();
  const successMessage = viewStaff?.updateSuccess;
  const errorMessage = viewStaff?.error;

  useEffect(() => {
    dispatch(resetStaffDetail());
    dispatch(selectCountryRequest());
    dispatch(StaffViewRequest(staffId));
  }, [staffId]);

  useEffect(() => {
    if (successMessage) {
      toast.success("Staff Updated Successfully", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetStaffDetail());
          navigate(STAFFS);
        },
      });
    }
  }, [successMessage]);
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(StaffViewRequest(staffId));
          dispatch(resetStaffDetail());
        },
      });
    }
  }, [errorMessage]);
  const role_name = roles.map((roles) => {
    return { value: roles.id, label: roles.name };
  });
  let userData = useSelector((state) => state.staffs?.Staff?.data || {});
 
  const roleName = useSelector((state) => state.roles?.roleDetails?.data || {});
  const selectedRole = { value: roleName.id, label: roleName.name };

  let status = userData?.status === "1" ? "Active" : "Inactive";

  const {
    handleSubmit,
    control,
    reset,
    setError,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      gender_type: "",
      dob: "",
      address: "",
      address2: "",
      pincode: "",
      country_code: "",
      city: "",
      state: "",
      country: "",
      phone: "",
      status: "",
    },

    mode: "onChange",
  });
  useEffect(() => {
    if (userData && userData.role_id) {
      dispatch(resetRoleState());
      dispatch(fetchRoleDetailsRequest(userData.role_id));
    }
  }, [dispatch, userData]);

 
  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      reset({
        staff_unique_id: userData.staff_unique_id || "",
        first_name: userData.first_name || "",
        last_name: userData.last_name || "",
        email: userData.email || "",
        role_id: userData?.Role
          ? {
              label: userData?.Role?.name,
              value: userData?.Role?.id,
            }
          : null,

        gender_type: userData.gender_type || "",
        dob: formatDateWithAmPm(userData.dob) || "",
        address: userData.address1 || "",
        address2: userData.address2 || "",
        pincode: userData.pincode || "",
        country_code: userData.country_code
          ? {
              label: userData?.country_code,
              value: userData?.country_code,
            }
          : null,
        city: userData.city
          ? {
              label: userData.city_name.replace("_", " "),
              value: userData.city,
            }
          : null,
        state: userData.state
          ? {
              label: userData.state_name.replace("_", " "),
              value: userData.state,
            }
          : null,
        country: userData.country
          ? {
              label: userData.country_name.replace("_", " "),
              value: userData.country,
            }
          : null,
        phone: userData.phone || "",
        status: userData.status === 1 ? "Active" : "Inactive",
      });
    }
   
  }, [userData, reset]);

  const formValue = watch();

  const countryId = formValue.country?.value;

  const stateId = formValue.state?.value;

  const countries = useSelector((state) => state.selector?.country?.data);

  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);

  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });
  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });
  const stateCount = useRef(0);
  const cityCount = useRef(0);
  useMemo(() => {
    if (countryId > 0 && stateCount.current > 0) {
      setValue("state", "");
      setValue("city", "");
    }
    if (countryId > 0) {
      dispatch(selectStateRequest(countryId));
      stateCount.current += 1;
    }
  }, [countryId]);

  useMemo(() => {
    if (stateId > 0 && cityCount.current > 0) {
      setValue("city", "");
    }
    if (stateId > 0) {
      dispatch(selectCityRequest(stateId));
      cityCount.current += 1;
    }
  }, [stateId]);
  const validateDOB = (value) => {
    const today = new Date();
    const dob = new Date(value);
    const age = today.getFullYear() - dob.getFullYear();
    const isFutureDate = dob > today;

    if (isFutureDate) {
      return "Date of Birth cannot be in the future.";
    }
    if (age < 18) {
      return "You must be at least 18 years old.";
    }
    return true;
  };
  const formFields = [
    {
      name: "staff_unique_id",
      label: "Staff Id",
      placeholder: "Enter Staff Id",
      icon: <AccountCircle />,
      rules: { required: "Staff Id is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "first_name",
      label: "First Name",
      placeholder: "Enter First Name",
      rules: { required: "First Name is required" },
      icon: <AccountCircle />,
      sm: 6,
      xs: 12,
    },
    {
      name: "last_name",
      label: "Last Name",
      placeholder: "Enter Last Name",
      rules: { required: "Last Name is required" },
      icon: <AccountCircle />,
      sm: 6,
      xs: 12,
    },
    {
      name: "email",
      label: "Email Address",
      placeholder: "Email Address",
      rules: {
        required: "Email Address is required",
        pattern: {
          value: /^\S+@\S+\.\S+$/,
          message: "Enter a valid email address",
        },
      },
      icon: <Email />,
      sm: 6,
      xs: 12,
    },
    {
      name: "role_id",
      label: "Role",
      placeholder: "Select Role",
      icon: <AssignmentInd />,
      options: role_name,
      rules: { required: "Role is required" },
      sm: 6,
      xs: 12,
    },
    {
      name: "country_code",
      options: countryForCode,
      label: "Code *",
      placeholder: "Select Country Code",
      rules: {
        required: "Code is Required",
      },
      sm: 2,
      xs: 4,
    },
    {
      name: "phone",
      label: "Mobile Number",
      placeholder: "Mobile Number",
      type: "Number",
      rules: {
        required: "Mobile Number is required",
        pattern: {
          value: /^\d+$/,
          message: "Enter only numeric digits",
        },
      },
      icon: <Phone />,
      sm: 4,
      xs: 8,
    },
    {
      name: "gender_type",
      label: "Gender",

      placeholder: "Select Gender",
      rules: { required: "Gender is required" },
      type: "radio",

      radioOptions: [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" },
      ],
      icon: <AssignmentInd />,
      sm: 6,
      xs: 12,
    },
    {
      name: "dob",
      label: "Date of Birth",
      placeholder: "",
      icon: <AssignmentInd />,
      type: "dob",
      rules: {
        required: "Date of Birth is required.",
        validate: validateDOB,
      },
      sm: 6,
      xs: 12,
    },
    {
      name: "address",
      label: "Address1",
      placeholder: "Enter Address",
      rules: { required: "Address1 is required" },
      icon: <LocationOn />,
      sm: 6,
      xs: 12,
    },
    {
      name: "address2",
      label: "Address2",
      placeholder: "Enter Address",
      icon: <LocationOn />,
      sm: 6,
      xs: 12,
    },

    {
      name: "country",
      label: "Country",
      placeholder: "Select Country",
      rules: { required: "Country is required" },
      icon: <LocationOn />,
      options: countryName,
      sm: 6,
      xs: 12,
    },
    {
      name: "state",
      label: "State",
      placeholder: "Select State",
      rules: { required: "State is required" },
      options: stateName,
      icon: <LocationOn />,
      sm: 6,
      xs: 12,
    },
    {
      name: "city",
      label: "City",
      placeholder: "Select City",
      rules: { required: "City is required" },
      icon: <LocationOn />,
      options: cityName,
      sm: 6,
      xs: 12,
    },

    {
      name: "pincode",
      label: "Pincode",
      placeholder: "Enter Pincode",
      type: "Number",
      rules: {
        required: "Pincode is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Enter a valid numeric pincode",
        },
      },
      icon: <LocationOn />,
      sm: 6,
      xs: 12,
    },
  ];
  if (viewLoading) {
    return <Loading text="Loading Staff details..." />;
  }
   return (
    <>
      <ToastContainer />
      <Box className="container">
        <Card>
          <CardContent className="card">
            <Typography variant="h5" className="form-heading">
              Update Staff
            </Typography>
            <form
              onSubmit={handleSubmit(async (data) => {
                try {
                  await dispatch(
                    staffUpdateRequest({
                      ...data,
                      city: data.city?.value || data.city,
                      state: data.state?.value || data.state,
                      country: data.country?.value || data.country,
                      status: data.status === "Active" ? 1 : 0,
                      id: staffId,
                      staff_unique_id: data.staff_unique_id,
                      country_code: data.country_code?.value,
                      dob: convertStaffDateFormat(data.dob),
                      role_id: data.role_id?.value,
                    })
                  );
               
                  dispatch(resetStaffDetail());
                } catch (error) {
                  console.error("Error submitting staff data:", error);
                }
              })}
            >
              <Grid
                className="content-top-height"
                container
                rowSpacing={4}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              >
                {formFields.map((field, index) => (
                  <Grid item xs={field.xs} sm={field.sm} key={index}>
                    <ControlledTextInputField
                      name={field.name}
                      control={control}
                      label={field.label}
                      placeholder={field.placeholder}
                      startAdornment={field.icon}
                      rules={field.rules}
                      value={field.value}
                      options={field.options}
                      defaultValue={field.defaultValue}
                      type={field.type}
                      radioOptions={field.radioOptions}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]?.message}
                    />
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <StatusRadioGroup
                    defaultValue={status}
                    name="status"
                    control={control}
                    rules={{ required: "status is required" }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box className="button-container">
                  <CustomButton
                    variant="contained"
                    className="cancel-button"
                    type="button"
                    text="Back"
                      onClick={() => page!==0?navigate(`/staffs`,{state:{page:page}}):navigate(-1)}
                  />
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    loading={editLoading}
                    type="submit"
                    text="Submit"
                  />
                </Box>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
